/* globals rp$, window, document, _satellite */

'use strict';
const get = require('lodash/get');
const debug = require('debug')('webstore:dtm');
const {
	trackPageViewEvent,
	trackPurchaseEvent,
	trackCheckoutEvent
} = require('public/js/lib/adobe-dtm-helper');

let digitalData = window.digitalData || {};
rp$(document).ready(function() {
	let retries = 0;
	function checkAdobeDTMLoaded() {
		if (typeof _satellite !== 'undefined' && get(digitalData, 'page')) {
			window.digitalData = digitalData;

			window.digitalData.newEvent = function(ev) {
				var event_ = {
					type : (ev && ev.type) ? ev.type : null,
					eventName : (ev && ev.eventName) ? ev.eventName : null,
					eventAction : (ev && ev.eventAction) ? ev.eventAction : null,
					attributes : (ev && ev.attributes) ? ev.attributes : {},
					timeStamp : (ev && ev.timeStamp) ? ev.timeStamp : new Date()
				};

				// Event array is updated and a window.trigger is fired at this point to alert the browser that a new event has occurred.
				window.digitalData.events.push(event_);

				debug('eventTrigger', event_);
				debug('digitalDataObject', window.digitalData);

				if (rp$) {
					rp$(window).trigger(event_);
				}

				return event_;
			};

			trackPageViewEvent();

			// Fire the purchase event if we're on a completed order page for a new order
			if (get(window, 'digitalData.page.category.pageType') === 'order-confirmation'
				&& get(window, 'digitalData.transaction.trackTransaction')
				&& get(window, 'digitalData.transaction.orderTotal', 0) > 0
			) {
				trackPurchaseEvent();
			}

			// Prepare to send a purchase event if the cart flyover 'Checkout' button is pressed
			rp$('.cart-flyout .cart-listing').on('click', '.place-order-button', function() {
				trackCheckoutEvent();
			});
		} else if (retries < 12) {
			// Adobe DTM script not loaded yet, give more time for async script to load
			retries++;
			setTimeout(checkAdobeDTMLoaded, 250);
		}
	}

	checkAdobeDTMLoaded();
});
